'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = resetPender;

var _actionTypes = require('./actionTypes');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * action creator for reset
 * 
 * @export
 * @returns redux action
 */
function resetPender() {
    return {
        type: _actionTypes2.default.RESET
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-pender/lib/resetPender.js
// module id = 313
// module chunks = 1